<script>
  import { LineString } from 'ol/geom'
  import { simpleGeometry } from '../../mixins'
  import { isLineCoords, GeometryType } from '../../ol-ext'
  import { assert, constant } from '../../utils'

  export default {
    name: 'VlGeomLineString',
    mixins: [
      simpleGeometry,
    ],
    props: {
      /* eslint-disable vue/require-prop-types */
      coordinates: {
        ...simpleGeometry.props.coordinates,
        validator: isLineCoords,
      },
      /* eslint-enable vue/require-prop-types */
    },
    computed: {
      type: /*#__PURE__*/constant(GeometryType.LINE_STRING),
    },
    methods: {
      /**
       * @returns {LineString}
       * @protected
       */
      createGeometry () {
        return new LineString(this.currentCoordinatesViewProj)
      },
      /**
       * @param {number[]} coordinates
       * @param {boolean} [viewProj=false]
       */
      setCoordinates (coordinates, viewProj = false) {
        assert(isLineCoords(coordinates), 'Invalid coordinates')

        this::simpleGeometry.methods.setCoordinates(coordinates, viewProj)
      },
    },
  }
</script>
